import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function AuthorSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#0D002B] relative overflow-hidden" data-id="element-54">
      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-55">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-56">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="w-full md:w-1/2 flex justify-center" data-id="element-57">
            <div className="relative w-full max-w-[400px]" data-id="element-58">
              <div className="absolute inset-0 bg-gradient-to-tr from-[#7C3AED] to-[#E5A83B] rounded-[40px] transform rotate-3 opacity-20 blur-lg" data-id="element-59"></div>
              <img src="https://cdn.magicpatterns.com/uploads/i9b2Qj7b1ucHunn4rr4NSm/Gemini_Generated_Image_dlzw6dlzw6dlzw6d.png" alt="Lic. Eduardo Coello" className="relative w-full h-auto rounded-[40px] object-cover shadow-2xl border-4 border-[#110038]" data-id="element-60" />
              <div className="absolute -bottom-6 -right-6 bg-[#110038] border border-[#7C3AED]/30 p-4 rounded-2xl shadow-xl" data-id="element-61">
                <p className="text-[#E5A83B] font-bold text-sm uppercase tracking-wider mb-1" data-id="element-62">
                  Autor
                </p>
                <p className="text-white font-serif font-bold text-lg" data-id="element-63">
                  Lic. Eduardo Coello
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: 30
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="w-full md:w-1/2" data-id="element-64">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 font-serif" data-id="element-65">
              ¿Por qué creé este protocolo?
            </h2>
            <div className="space-y-6 text-[#C4B5FD] font-sans text-lg leading-relaxed" data-id="element-66">
              <p data-id="element-67">
                Después de años trabajando con parejas en crisis, me di cuenta
                de un patrón destructivo:{' '}
                <strong data-id="element-68">
                  la mayoría de las terapias tradicionales son demasiado lentas
                </strong>{' '}
                para la urgencia que requiere una relación al borde del colapso.
              </p>
              <p data-id="element-69">
                Cuando estás en medio de una "guerra fría" en casa, no necesitás
                analizar tu infancia durante 6 meses. Necesitás un{' '}
                <em data-id="element-70">"cese al fuego" inmediato</em>.
              </p>
              <p data-id="element-71">
                Por eso diseñé este protocolo. Es un mapa de ruta táctico,
                directo y sin vueltas, pensado específicamente para las
                presiones del día a día. Mi objetivo no es que se conviertan en
                monjes zen, sino que vuelvan a ser un equipo.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}